import { render, staticRenderFns } from "./verification_list.vue?vue&type=template&id=00b751ac&scoped=true"
import script from "./verification_list.vue?vue&type=script&lang=js"
export * from "./verification_list.vue?vue&type=script&lang=js"
import style0 from "./verification_list.vue?vue&type=style&index=0&id=00b751ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_61f4c95fbe53a3b57a2489edae5a9b2f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b751ac",
  null
  
)

export default component.exports